import { authHeaders, getRequest, invokeApi, postRequest } from '../components/network/apiclient';
import { friendsEndpoint } from './endpoint';

export const fetchFriendList = (token, onSuccess, onError) =>
    invokeApi(getRequest(friendsEndpoint.listPath(), authHeaders(token)), onSuccess, onError);

export const fetchFriendGames = (token, onSuccess, onError, friendUserId) =>
    invokeApi(postRequest(friendsEndpoint.gamesPath(), authHeaders(token), { friendUserId }), onSuccess, onError);
